/** User-facing service area messaging (keep in sync with SUPPORTED_DISTRICTS). */

export const SERVICE_AREA_SHORT_LIST = 'Kochi, Thiruvananthapuram & Calicut';

export const SERVICE_AREA_LOGIN_BANNER =
  'Fixome is available in Kochi (Ernakulam), Thiruvananthapuram, and Calicut.';

export const SERVICE_AREA_REGISTER_BANNER =
  `Book trusted home services in ${SERVICE_AREA_SHORT_LIST}.`;

export const SERVICE_AREA_BOOKING_NOTE =
  `We operate in selected areas across ${SERVICE_AREA_SHORT_LIST}. Our technician will contact you in advance to confirm your exact address before arrival.`;

export const SERVICE_AREA_OFFERS_BADGE = `Available in ${SERVICE_AREA_SHORT_LIST}`;

export const SERVICE_AREA_GEO_SUMMARY =
  'Fixome serves Kochi (Ernakulam), Thiruvananthapuram, and Calicut across Kerala, India.';

export const SERVICE_AREA_BOOKING_HOWTO =
  'Open fixome.in, search or pick your service (for example plumbing or AC repair), choose how soon you need us, enter your address in our service area, and confirm. You can also reach us on WhatsApp at +91 70126 89824 during service hours 8am–7pm.';
